module.exports = __webpack_public_path__ + "img/info-notification-icon.350012c7.png";